import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LogProvider } from './LogProvider.js';
export var LogFile = /*#__PURE__*/function (_LogProvider) {
  _inherits(LogFile, _LogProvider);

  var _super = _createSuper(LogFile);

  function LogFile(content, limit) {
    var _this;

    _classCallCheck(this, LogFile);

    _this = _super.call(this, limit); // newlines that aren't proceeded by a '}' are either invalid or cary no meaning

    content = content.replace(/([^}])\s*([\n\r]+)/g, "$1");
    _this.content = content;
    _this.lines = _this.content.split('\n');
    return _this;
  }

  _createClass(LogFile, [{
    key: "loadEntries",
    value: function () {
      var _loadEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(offset) {
        var count,
            start,
            end,
            entries,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                count = _args.length > 1 && _args[1] !== undefined ? _args[1] : 50;
                start = this.lines.length - offset;
                end = Math.max(start - count - 2, 0);
                entries = this.lines.slice(end, start).reverse().map(this.tryParseJSON).map(function (entry) {
                  if (!entry.id) {
                    entry.id = Math.random() * 10000;
                  }

                  return entry;
                });
                return _context.abrupt("return", {
                  data: entries
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadEntries(_x) {
        return _loadEntries.apply(this, arguments);
      }

      return loadEntries;
    }()
  }, {
    key: "tryParseJSON",
    value: function tryParseJSON(json) {
      try {
        return JSON.parse(json);
      } catch (e) {
        // fix unescaped message json
        var startPos = json.indexOf('"message":"') + '"message":"'.length;
        var endPos = json.lastIndexOf('","level":');
        var start = json.substr(0, startPos);
        var end = json.substr(endPos);
        var message = json.substr(startPos, endPos - startPos);
        var escapedMessage = message.replace(/([^\\]|^)["]/g, '$1\\"');
        json = start + escapedMessage + end;

        try {
          return JSON.parse(json);
        } catch (e) {
          console.log('Error while parsing log message:');
          console.log(json);
          console.error(e);
        }
      }
    }
  }]);

  return LogFile;
}(LogProvider);